export default __webpack_public_path__ + "8.7f23b5.svg";